module.exports = __webpack_public_path__ + "media/images/home/testimonials/lukas_texl_2x-9f6c9a67cd4c3ad7e15eb79f734fb4d4.png";